import React from "react";
import { HoverCard } from "../resultsPrimitives/hoverCardPrimitives.jsx";
import { PRIMARY } from "./Fields.jsx";

export default function ValidateSheetButton({ reasons, onValidate, subject = "le relevé", buttonLabel = "Valider le relevé", describedBy,
  className = PRIMARY, hoverTitle = "Validation indisponible", introduction = `Avant de valider ${subject} :`, helpLabel = "Pourquoi la validation est indisponible" }) {
  const disabled = reasons.length > 0;
  const button = <button type="button" className={`${className} ${disabled ? "pointer-events-none" : ""}`}
    aria-describedby={describedBy} disabled={disabled} onClick={onValidate}>{buttonLabel}</button>;
  if (!disabled) return button;
  return <HoverCard title={hoverTitle} placement="top-end" delay={80} maxWidth={400}
    openOnTouch openOnClick referenceAsChild interactive flat compactTitle
    accentColor="var(--hovercard-accent-warning)" content={<div className="grid max-h-64 gap-2 overflow-y-auto text-xs">
      <p>{introduction}</p>
      <ul className="list-disc space-y-1 pl-4">{reasons.map(reason => <li key={reason} className="whitespace-pre-line">{reason}</li>)}</ul>
    </div>}>
    <span className="inline-flex cursor-not-allowed rounded-[4px] focus-visible:outline-accent" tabIndex={0}
      aria-label={helpLabel}>{button}</span>
  </HoverCard>;
}
